import CellList from './CellList';

export default CellList;